import React from 'react'
import PropTypes from 'prop-types'
import { formatPerExtensed, getDayOfWeek } from '../../../utils/date'
import TimelineItem from '../TimelineItem/TimelineItem'
import styles from './timeline.module.scss'

const Timeline = (props) => {
  const { date, events } = props
  return (
    <div className={styles.timeline}>
      <label className={styles.timelineTitle}>
        {`${getDayOfWeek(date)} • ${formatPerExtensed(date)}`}
      </label>
      <div className={styles.timelineContent}>
        {events.map((item) => (
          <TimelineItem
            key={item.id}
            userName={item.userName}
            interactionId={item.interactionId}
            category={item.categoryId}
            store={item.store}
            indicators={item.indicators}
            description={item.description}
            supervisor={item.supervisor}
          />
        ))}
      </div>
    </div>
  )
}

Timeline.defaultProps = {
  events: []
}

Timeline.propTypes = {
  date: PropTypes.string.isRequired,
  events: PropTypes.array
}

export default Timeline
